export enum Privilege {
  none = 0,
  shiftSupervisor = 1 << 1,
  manager = 1 << 2,
}

export namespace Privilege {
  export function getValue(privilege) {
    return isNaN(privilege) ? Privilege[privilege] : privilege;
  }

  export function getPrivileges(): Privilege[] {
    return [Privilege.manager, Privilege.shiftSupervisor];
  }
  export function getSelectablePrivileges(): Privilege[] {
    return [Privilege.shiftSupervisor, Privilege.manager];
  }
  export function canManageSet(): Privilege[] {
    return [Privilege.manager, Privilege.shiftSupervisor];
  }
  export function canManage(privilege: Privilege) {
    return (
      Privilege.hasPrivilege(privilege, Privilege.manager) ||
      Privilege.hasPrivilege(privilege, Privilege.shiftSupervisor)
    );
  }

  export function hasPrivilege(
    privilege: Privilege,
    privilegeToCheck: Privilege,
  ) {
    return (privilege & privilegeToCheck) == privilegeToCheck;
  }
  export function addPrivilege(
    privilege: Privilege,
    privilegeToAdd: Privilege,
  ) {
    return privilege | Privilege.getValue(privilegeToAdd);
  }
  export function removePrivilege(
    privilege: Privilege,
    privilegeToRemove: Privilege,
  ) {
    return (
      (privilege | Privilege.getValue(privilegeToRemove)) ^
      Privilege.getValue(privilege)
    );
  }

  export function getNames(privilege: Privilege) {
    return Privilege.getPrivileges()
      .filter((k) => Privilege.hasPrivilege(privilege, k))
      .map((k) => Privilege.getIndividualString(k));
  }

  export function getIndividualString(privilege: Privilege): string {
    switch (privilege) {
      case Privilege.manager:
        return "Manager";
      case Privilege.shiftSupervisor:
        return "Shift Supervisor";
      default:
        return "None";
    }
  }
}
